import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getSysDeptList, findSysDept, deleteSysDept, createSysDept, updateSysDept, getDeptTreeList } from "@/api/sys_dept";
import infoList from "@/components/mixins/infoList";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { getDict } from "@/utils/dictionary";
export default {
  name: 'Dept',
  mixins: [infoList],
  data: function data() {
    return {
      // 遮罩层
      loading: true,
      // 表格树数据
      listApi: getDeptTreeList,
      // 部门树选项
      deptOptions: [],
      // 弹出层标题
      title: '',
      isEdit: false,
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      // 查询参数
      queryParams: {
        deptName: undefined,
        status: undefined
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        parentId: [{
          required: true,
          message: this.$t('department.parent_required'),
          trigger: 'blur'
        }],
        deptName: [{
          required: true,
          message: this.$t('department.name_required'),
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: this.$t('department.sort_required'),
          trigger: 'blur'
        }],
        email: [{
          type: 'email',
          message: this.$t('department.email.format'),
          trigger: ['blur', 'change']
        }],
        phone: [{
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: this.$t('department.telephone_format'),
          trigger: 'blur'
        }]
      }
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getTableData();
          case 1:
            _context.next = 2;
            return getDict("sys_normal_disable");
          case 2:
            res = _context.sent;
            this.statusOptions = res;
            console.log(this.statusOptions);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    /** 查询部门列表 */getList: function getList() {
      var _this = this;
      this.loading = true;
      getSysDeptList(this.queryParams).then(function (response) {
        _this.deptList = response.data;
        _this.loading = false;
      });
    },
    statusFilter: function statusFilter(value) {
      var target = this.statusOptions.filter(function (item) {
        return item.value === parseInt(value.status);
      })[0];
      return target && "".concat(target.label);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /** 转换部门数据结构 */normalizer: function normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.deptId,
        label: node.deptName,
        children: node.children
      };
    },
    /** 查询部门下拉树结构 */getTreeselect: function getTreeselect(e) {
      var _this2 = this;
      getSysDeptList().then(function (response) {
        _this2.deptOptions = [];
        if (e === 'update') {
          var dept = {
            deptId: 0,
            deptName: _this2.$t('department.name_default'),
            children: [],
            isDisabled: true
          };
          dept.children = response.data;
          _this2.deptOptions.push(dept);
        } else {
          var _dept = {
            deptId: 0,
            deptName: _this2.$t('department.name_default'),
            children: []
          };
          _dept.children = response.data;
          _this2.deptOptions.push(_dept);
        }
      });
    },
    // 字典状态字典翻译
    statusFormat: function statusFormat(row) {
      return this.selectDictLabel(this.statusOptions, row.status);
    },
    // 取消按钮
    cancel: function cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset: function reset() {
      this.form = {
        deptId: undefined,
        parentId: undefined,
        deptName: undefined,
        sorc: undefined,
        leader: undefined,
        phone: undefined,
        email: undefined,
        status: '0'
      };
    },
    /** 搜索按钮操作 */handleQuery: function handleQuery() {
      this.getList();
    },
    /** 新增按钮操作 */handleAdd: function handleAdd(row) {
      this.reset();
      if (row !== undefined) {
        this.form.parentId = row.ID;
      }
      this.setOptions();
      this.open = true;
      this.title = this.$t('common.add');
      this.isEdit = false;
    },
    setOptions: function setOptions() {
      this.deptOptions = [{
        ID: 0,
        title: this.$t('department.parent_node')
      }];
      this.setDeptOptions(this.tableData, this.deptOptions, false);
    },
    setDeptOptions: function setDeptOptions(deptData, optionsData, disabled) {
      var _this3 = this;
      deptData && deptData.map(function (item) {
        if (item.children && item.children.length) {
          //console.log(item);
          var option = {
            title: item.deptName,
            ID: item.ID,
            disabled: disabled || item.ID == _this3.form.ID,
            children: []
          };
          _this3.setDeptOptions(item.children, option.children, disabled || item.ID == _this3.form.ID);
          optionsData.push(option);
        } else {
          var _option = {
            title: item.deptName,
            ID: item.ID,
            disabled: disabled || item.ID == _this3.form.ID
          };
          optionsData.push(_option);
        }
      });
    },
    /** 修改按钮操作 */handleUpdate: function () {
      var _handleUpdate = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.setOptions();
              _context2.next = 1;
              return findSysDept({
                ID: row.ID
              });
            case 1:
              res = _context2.sent;
              this.open = true;
              this.title = this.$t('common.edit');
              this.isEdit = true;
              if (res.code == 0) {
                this.form = res.data.resysDept;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleUpdate(_x) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }(),
    /** 提交按钮 */
    submitForm: function submitForm() {
      var _this4 = this;
      if (this.form.ID !== undefined) {
        updateSysDept(this.form).then(function (response) {
          if (response.code === 0) {
            _this4.$message({
              type: 'success',
              message: _this4.$t('common.success')
            });
            _this4.open = false;
            _this4.getTableData();
          } else {
            _this4.$message({
              type: 'error',
              message: _this4.$t('common.error')
            });
          }
        });
      } else {
        createSysDept(this.form).then(function (response) {
          if (response.code === 0) {
            _this4.$message({
              type: 'success',
              message: _this4.$t('common.success')
            });
            _this4.open = false;
            _this4.getTableData();
          } else {
            _this4.$message({
              type: 'warning',
              message: _this4.$t('common.error')
            });
          }
        });
      }
    },
    /** 删除按钮操作 */handleDelete: function handleDelete(row) {
      var _this5 = this;
      this.$confirm(this.$t('common.delete_warning'), '', {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        return deleteSysDept({
          ID: row.ID
        });
      }).then(function () {
        _this5.getTableData();
        _this5.$message({
          type: 'success',
          message: _this5.$t('common.success')
        });
      }).catch(function () {});
    }
  },
  filter: {}
};